import { useState } from 'react';
import { useAuth } from "./AuthProvider";
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { useFormik } from 'formik';
import { PLAYER, GAME_MASTER, ADMIN } from './Roles';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

const validationSchema = (t) => Yup.object({
  username: Yup.string()
      .email(t('add-user.validation.invalid-email'))
      .required(t('add-user.validation.username-required'))
});

const AddUser = ({ show, onClose, setCreating, onAdded }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const [error, setError] = useState();
    const formik = useFormik({
         initialValues: {
           username: '',
           role: GAME_MASTER
         },
         validationSchema: validationSchema(t),
         onSubmit: values => {
            axios.post('api/users', values, {
                  headers: {
                    Authorization: `Bearer ${auth.token}`,
                    'Content-Type': 'application/json'
                  },
                })
              .then(response => {
                const data = response.data;
                onAdded(data);
                setCreating(false);
                setError(false);
              })
              .catch(error => {
                  console.log(error);
                  if (error.status === 409) {
                      setError(t('add-user.user-exists'));
                  } else {
                      setError(error.message || t('add-user.error'));
                  }
              });
         },
       });

    return (
            <Modal show={show} onHide={onClose}>
              <Form onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>{t('add-user.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('add-user.username')}</Form.Label>
                      <Form.Control
                        id="username"
                        name="username"
                        type="email"
                        placeholder={t('add-user.enter-email')}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.username}
                        isInvalid={formik.touched.username && !!formik.errors.username}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.username}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>{t('add-user.role')}</Form.Label>
                      <Form.Select
                        id="role"
                        name="role"
                        onChange={formik.handleChange}
                        value={formik.values.role}>
                        <option value={ADMIN}>{t('user.role.ADMIN')}</option>
                      </Form.Select>
                    </Form.Group>
                    {error && <div className="alert alert-danger" role="alert">
                        {error}
                      </div>}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={onClose}>{t('common.cancel')}</Button>
                  <Button type="submit" variant="primary" disabled={!(formik.isValid && formik.dirty)}>{t('common.add')}</Button>
                </Modal.Footer>
              </Form>
            </Modal>
      );
};

export default AddUser;